import React, { useState, useEffect } from "react";
import { Upload, Button, Typography, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import config from "../../../config";

const baseUrl = config.baseUrl;

const { Title } = Typography;

// Utilidad para convertir URL a base64
const urlToBase64 = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const ImagenUploader = ({ titulo, onChange, value }) => {
  const [imagenes, setImagenes] = useState([]);

  useEffect(() => {
    const procesarImagenes = async () => {
      if (!value) {
        setImagenes([]);
        onChange([]);
        return;
      }

      // Normaliza a array
      const entradas = Array.isArray(value) ? value : [value];

      // ¿Hay al menos una URL que no empiece por 'data:image'?
      const hayURLs = entradas.some(
        (src) => typeof src === "string" && !src.startsWith("data:image")
      );

      if (!hayURLs) {
        // Solo base64: setea y no dispara onChange
        const imgs = entradas.map((base64, i) => ({
          uid: `-${i}`,
          name: `imagen-${i}`,
          url: base64,
        }));
        setImagenes(imgs);
        return;
      }

      // Si aquí, tenemos rutas relativas (o absolutas): convertimos una sola vez
      const base64List = await Promise.all(
        entradas.map(async (src) => {
          // Si ya es base64, déjalo
          if (typeof src === "string" && src.startsWith("data:image")) {
            return src;
          }
          // Si no, prepón el dominio y convierte
          const fullUrl = src.startsWith("http")
            ? `${src}?t=${Date.now()}`
            : `${baseUrl}${src}?t=${Date.now()}`;
          try {
            return await urlToBase64(fullUrl);
          } catch (e) {
            console.error("Error convirtiendo URL a base64:", fullUrl, e);
            return null;
          }
        })
      );

      // Filtra nulos y setea
      const filtradas = base64List.filter(Boolean);
      const imgs = filtradas.map((b64, i) => ({
        uid: `-${i}`,
        name: `imagen-${i}`,
        url: b64,
      }));

      setImagenes(imgs);
      onChange(filtradas); // Disparamos una sola vez con todos los base64
    };

    procesarImagenes();
  }, [value]);

  const handleChange = async (info) => {
    if (info.fileList.length > 0) {
      const newImagenes = await Promise.all(
        info.fileList.map(async (file) => {
          if (file.url)
            return { uid: file.uid, name: file.name, url: file.url };

          const base64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file.originFileObj);
          });

          return { uid: file.uid, name: file.name, url: base64 };
        })
      );

      setImagenes(newImagenes);
      onChange(newImagenes.map((img) => img.url));
    } else {
      setImagenes([]);
      onChange([]);
    }
  };

  const beforeUpload = (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];

    if (!allowedTypes.includes(file.type)) {
      message.error(
        "Solo se permiten imágenes en formato JPEG, JPG, PNG o GIF."
      );
      return Upload.LIST_IGNORE;
    }

    return false;
  };

  return (
    <div>
      <Title level={4}>{titulo}</Title>
      <Upload
        multiple
        fileList={imagenes}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        action={""}
      >
        <Button icon={<UploadOutlined />}>Cargar Imágenes</Button>
      </Upload>
      <div style={{ marginTop: 16 }}>
        {imagenes.map((img) => {
          const isBase64 = img.url.startsWith("data:image");
          const src = isBase64 ? img.url : `${img.url}?t=${Date.now()}`;
          return (
            <img
              key={img.uid}
              src={src}
              alt={img.name}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                marginRight: "10px",
                marginBottom: "10px",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ImagenUploader;
